import React from 'react';
const Tick = () => (React.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M20.641 5.232a1.001 1.001 0 00-1.409.128L9.807 16.67l-5.252-3.501a1 1 0 10-1.11 1.664l6 4a1.006 1.006 0 001.324-.193l10-12a1.001 1.001 0 00-.128-1.408z", fill: "currentColor" })));
export default Tick;
//# sourceMappingURL=Tick.js.map